var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.searchTree},[_c('ul',{class:_vm.$style.catalogs,attrs:{"data-level":"0"}},_vm._l((_vm.catalogsTree),function(item){return _c('SearchTreeItem',{key:item.id,attrs:{"item":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }